<div class="layout-ParentDiv innerDiv">
	<div class="layout-dashboard" [ngClass]="hide ? 'responsiveHide-column' : 'responsiveShow-column'">
		<div class="mainDivHeader">
			<div class="leftdiv">
				<h4>Role List <span class="badge">{{totalRecords }}</span></h4>
			</div>
			<div class="rightDiv">
				<button class="exportBTn" (click)="exportExcel()"> <span><img
							src="../../../assets/images/backend-image/header/exportIcon.svg" alt=""></span>
					Export</button>
				<button class="addBTn" (click)="addNewRole()"> <span><img
							src="../../../assets/images/backend-image/header/plus.svg" alt=""></span> Add Role</button>
			</div>
		</div>
		<div class="mainDivBody">
			<div class="date-filterDiv">
				<ul class="filtersList">
					<li>
						<p-dropdown inputId="searchfield" [options]="searchBy" [(ngModel)]="searchby"
							placeholder="Select Field" optionLabel="label"></p-dropdown>
					</li>
					<li>
						<p-calendar placeholder="From: dd / mm / yy" appendTo="body" monthNavigator="true"
							yearNavigator="true" yearRange="2022:2050" [(ngModel)]="startDate" class="p-calendar w-100"
							inputId="calendar" dateFormat="dd/mm/yy" [showIcon]="true"></p-calendar>
					</li>
					<li>
						<p-calendar placeholder="To: dd / mm / yy" appendTo="body" monthNavigator="true"
							yearNavigator="true" yearRange="2022:2050" [(ngModel)]="endDate" class="p-calendar"
							inputId="calendar" dateFormat="dd/mm/yy" [showIcon]="true"></p-calendar>
					</li>
					<li>
						<button (click)="loadRoles($event)" class="searchFilterBtn">
							<img src="../../../assets/images/backend-image/common-images/search.svg" alt="">
						</button>
					</li>
					<li>
						<button class="clearFilterBtn" (click)="clear()">
							<img src="../../../assets/images/backend-image/common-images/delete.svg" alt="">
							<span>Clear All</span>
						</button>

					</li>
				</ul>

			</div>
			<div class="maintableDiv">
				<div class="tableParanet">
					<p-table class="p1-table-columns" #dt [value]="rolelist" [paginator]="true" [rows]="10"
						[lazy]="true" (onLazyLoad)="loadRoles($event)" [totalRecords]="totalRecords" [loading]="loading"
						[rowsPerPageOptions]="paginationOption" paginatorPosition="bottom" autoLayout="true"
						styleClass="p-datatable-gridlines p-datatable-striped">
						<ng-template pTemplate="header" let-columns>
							<tr>
								<th pSortableColumn="user_role_name" class="nameTd">
									<div class="p-d-flex p-jc-between p-ai-center">
										Name
										<p-sortIcon field="user_role_name"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="createdBy" class="createdByTd">
									<div class="p-d-flex p-jc-between p-ai-center">
										Created By
										<p-sortIcon field="createdBy"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="created_at" class="createdDateTd">
									<div class="p-d-flex p-jc-between p-ai-center">
										Date of Creation
										<p-sortIcon field="created_at"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="updatedby" class="modifiedByTd">
									<div class="p-d-flex p-jc-between p-ai-center">
										Modified By
										<p-sortIcon field="updatedby"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="updated_at" class="updatedDateTd">
									<div class="p-d-flex p-jc-between p-ai-center">
										Last Modified On
										<p-sortIcon field="updated_at"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="status" class="statusTd">
									<div class="p-d-flex p-jc-between p-ai-center">
										Status
										<p-sortIcon field="status"></p-sortIcon>
									</div>
								</th>
								<th class="actionTD p-frozen-column"> 
										Action 
								</th>
							</tr>
							<tr>
								<th [ngSwitch]="user_role_name" class="nameTd">
									<input pInputText type="text"
										(keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'user_role_name', 'contains')"
										style="width: 90px;"
										[value]="dt.filters['user_role_name'] ? dt.filters['user_role_name'].value : ''"  [(ngModel)]="user_role_name"/>
								</th>
								<th [ngSwitch]="createdBy">
									<input pInputText type="text"
										(keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'createdBy', 'contains')"
										style="width: 90px;"
										[value]="dt.filters['createdBy'] ? dt.filters['createdBy'].value : ''"  [(ngModel)]="createdBy"/>
								</th>
								<th [ngSwitch]="created_at" class="col-width  date-col-width">
									<p-calendar appendTo="body" #pCalendarId class="p-column-filter" inputId="calendar"
										dateFormat="dd/mm/yy"
										(onSelect)="setDownloadFlag(); dt.filter($event,'created_at', 'dateIs')"
										monthNavigator="true" yearNavigator="true" yearRange="2022:2050"
										[showIcon]="true" [(ngModel)]="calvalue"></p-calendar>
								</th>
								<th [ngSwitch]="updatedby">
									<input pInputText type="text"
										(keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'updatedBy', 'contains')"
										style="width: 90px;"
										[value]="dt.filters['updatedBy'] ? dt.filters['updatedBy'].value : ''"  [(ngModel)]="updatedBy"/>
								</th>
								<th [ngSwitch]="updated_at" class="col-width">

									<p-calendar appendTo="body" #pCalendarId class="p-column-filter" inputId="calendar"
										dateFormat="dd/mm/yy"
										(onSelect)="setDownloadFlag(); dt.filter($event,'updated_at', 'dateIs')"
										monthNavigator="true" yearNavigator="true" yearRange="2022:2050"
										[showIcon]="true" [(ngModel)]="calvalue1"></p-calendar>
								</th>
								<th [ngSwitch]="status" class="col-width status-col-width">
									<p-dropdown #pDropDownId [options]="statuses" [style]="{'width':'100%'}"
										(onChange)="setDownloadFlag(); dt.filter($event.value, 'status', 'equals')"
										styleClass="p-column-filter" placeholder="Select Status" [showClear]="true">
										<ng-template let-option pTemplate="item">
											<span
												[class]="'customer-badge status-' + option.value">{{option.label}}</span>
										</ng-template>
									</p-dropdown>
								</th>
								<!-- <th class="actionTD p-frozen-column">
										<div class="buttonColumn">
										<button class="addBTn" (click)="addColumns()"
											[ngClass]="hide ? 'show-column ' : 'hide-column'">
											+ Show Column
										</button>
										<button class="removeBTn" (click)="removeColumns()"
											[ngClass]="hide ? 'hide-column' : 'show-column '">
											- Hide Column
										</button>

									</div>
								</th> -->
							</tr>
						</ng-template>
						<ng-template pTemplate="body" let-role>
							<tr class="p-selectable-row">
								<td class="nameTd">
									{{role.user_role_name | titlecase}}
								</td>
								<td class="createdByTd">
									{{role.createdBy}}
								</td>
								<td class=" date-col-width">
									{{role.created_at | date: 'dd/MM/yyyy'}}
								</td>
								<td>
									{{role.updatedBy}}
								</td>
								<td>
									{{role.updated_at | date: 'dd/MM/yyyy'}}
								</td>
									<td class="statusTD">
										<div class="swichTable">
										<p-inputSwitch [(ngModel)]="role.status" class="d-flex"
											(onChange)="changeStatus(role)"></p-inputSwitch>
										<div class="label activeText" *ngIf="role.status">
											Active
										</div>
										<div class="label InActiveText" *ngIf="!role.status">
											Inactive
										</div>
									</div>

									<!-- <div class="status-div">
										<span *ngIf="role.status">
											<p-tag styleClass="mr-2" severity="success" value="Active"></p-tag>
										</span>
										<span *ngIf="!role.status">
											<p-tag severity="danger" value="In-Active"></p-tag>
										</span>
										<p-inputSwitch [(ngModel)]="role.status" class="d-flex"
											(onChange)="changeStatus(role)"></p-inputSwitch>
									</div> -->

								</td>
								<td class="actionTD p-frozen-column">
										<ul class="actionList">
										
										<li  *ngIf="!role.default_data">
											<button (click)="editRole(role.id)"
												class="editBtn"><img
													src="../../../assets/images/backend-image/common-images/editeBtn.svg"></button>
										</li>
										<li>
											<button (click)="deleteRole(role)" class="deleteBtn"><img
													src="../../../assets/images/backend-image/common-images/deleteBtn.svg"></button>
										</li>
										<li>
											<button (click)="viewRole(role.id)"
												class="viewBtn"><img
													src="../../../assets/images/backend-image/common-images/view.svg"></button>
										</li>
									</ul> 
								</td>
							</tr>
						</ng-template>
						<ng-template pTemplate="emptymessage">
							<tr>
								<td colspan="7">No Roles found.</td>
							</tr>
						</ng-template>
					</p-table>

				</div>
			</div>

		</div>

		<p-confirmDialog [style]="{width: '400px'}" id="confirmDialog"></p-confirmDialog>
	</div>
</div>